import { render, staticRenderFns } from "./ModalPlugin.vue?vue&type=template&id=89dc162c&"
import script from "./ModalPlugin.vue?vue&type=script&lang=js&"
export * from "./ModalPlugin.vue?vue&type=script&lang=js&"
import style0 from "./ModalPlugin.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../code/tibava/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports